import type { IconSize } from '@freelancer/ui/icon';

export interface SocialUrls {
  facebook?: string;
  twitter?: string;
  youtube?: string;
  instagram?: string;
  linkedin?: string;
  pinterest?: string;
}

export enum SocialButtonColor {
  LIGHT = 'light',
  DARK = 'dark',
  COLORED = 'colored',
  FOREGROUND = 'foreground',
}

export enum SocialButtonType {
  ICON = 'icon',
  BUTTON = 'button',
}

export type SocialButtonSize = IconSize.SMALL | IconSize.MID | IconSize.LARGE;
